export default {
    // 登录接口
    faceLogin(params) {
        return app.http.ajax({
            method: "post",
            url: "/csface-server/user/parentLogin",
            params: params,
        });
    },
    // 登录接口
    faceSendCode(params) {
        return app.http.ajax({
            method: "post",
            url: "/csface-server/user/sendCode",
            params: params,
        });
    },
    // 获取脸到app下载链接
    getAppstoreUrl(params) {
        return app.http.ajax({
            method: "get",
            url: "/csface-server/business/getAppstoreUrl",
            params: params
        });
    },
};